export default __webpack_public_path__ + "static/media/marker.05937dde.svg";